<template>
    <div>
        <!-- 导航栏 -->
        <header class="nav-header">
            <Navi/>
        </header>
        <!-- 主体内容 -->
        <div class="main">
            <router-view/>
        </div>
        <!-- 底部栏 -->
        <footer class="nav-footer">
            <Footer/>
        </footer>
    </div>
</template>

<script>
    import Navi from '../components/Navi/Navi'
    import Footer from '../components/Footer/Footer'
    export default {
        data() {
            return {
                
            }
        },
        components:{
            Navi,Footer
        }
    }
</script>

<style scoped>
    .nav-header{
        width:100%;
        height:8rem;
        background:#fff;
        position: fixed;
        top:0;
        z-index: 999;
    }
    .main{
        margin-top: 8rem;
        width: 100%;
        overflow: hidden;
    }
    @media (max-width: 767px){
        .nav-header{
            height:3.4rem;
        }
        .main{
            margin-top: 3.4rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Layout.vue